export default __webpack_public_path__ + "resources/docs/4_effective_credit_management_compressed.ec9e7eb9.pdf";